// Admins can override a featured product's Mindbody name from the staff portal
// (store.topItems[n].displayName). Purchases still key off the item id — this
// only changes what the client reads.
export function itemDisplayName(item) {
  return item?.displayName || item?.name || "";
}
